export const getSelectedTierIds = (tierIds, availableTiers = []) => availableTiers.reduce((acc, tier) => {
    return {
        ...acc,
        [tier.id]: tierIds.indexOf(tier.id) !== -1,
    };
}, {});
